// @flow

import React from 'react'
import { connect } from 'react-redux'
import bindAll from 'lodash/bindAll'
import initializers from '../../../dependencies/initializers'
import _axios from '../../../dependencies/_axios'
import { withRouter } from "react-router"
import Loader from '../../partials/Loader'
type Props = {
	interviewCode: string
};

class InviteInterviewsWithCode extends React.Component<Props> {
	constructor(props) {
		super(props)

		bindAll(this, [
			'handleCheckInterviewCode'
		])
	}

	handleCheckInterviewCode() {
		const { interviewCode, history } = this.props

		_axios({
			url: `/code/${interviewCode}?debug=false`,
			timeout: 200000,
			method: 'get',
			crossdomain: true
		})
		.then((data) => {
			const interviewCode = data.data.interview_code
			window.location = initializers.qna_host + '/code/' + interviewCode
		})
		.catch((error) => {
			history.push('/notfound')
		})
	}

	componentDidMount() {
		this.handleCheckInterviewCode()
	}

	render() {
		return <Loader />
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		interviewCode: ownProps.match.params.interviewCode
	}
}

export default withRouter(connect(mapStateToProps, null)(InviteInterviewsWithCode))
